module.exports = __webpack_public_path__ + "static/iPad-Lightning-2dfc59542a87ad067256bc5237fa0d1d.png";